export const MODIFY_APPSUMO_PLAN_NAME = 'MODIFY_APPSUMO_PLAN_NAME';

export function modifyAppsumoPlanName(appsumoPlanName){
    return {
        type: MODIFY_APPSUMO_PLAN_NAME,
        mainState: {
            appsumoPlanName: appsumoPlanName
        }
    }
}